import type { ConfluenceDatabase } from '../../types';

export const isConfluenceDatabase = (entity: any): entity is ConfluenceDatabase => {
	return entity.__typename === 'ConfluenceDatabase';
};

export const getConfluenceDatabaseLink = (database: ConfluenceDatabase): string | null => {
	const { base, webUi } = database.links ?? {};

	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}

	return `${base}${webUi}`;
};
